module.exports = __webpack_public_path__ + "img/banner1.f937b41e.png";